import {ContactTypeEnum} from './Contact';

export interface IDevice {
    id: number;
    name: string;
    description?: string;
    mask?: boolean;
    contact_type_id: number;
    contact_type: ContactTypeEnum;
    address: string;
    device_name?: string;
    proposed_device_name?: string;
    active: boolean;
    individual_id: number;
}

export class Device implements IDevice {
    id: number;
    name: string;
    description?: string;
    mask?: boolean;
    contact_type_id: number;
    contact_type: ContactTypeEnum;
    address: string;
    device_name?: string;
    proposed_device_name?: string;
    active: boolean;
    individual_id: number;

    constructor(source?: Device) {
        this.id = source && source.id || null;
        this.name = source && source.name || null;
        this.description = source && source.description || null;
        this.mask = source && source.mask || null;
        this.contact_type_id = source && source.contact_type_id || null;
        this.contact_type = source && source.contact_type || null;
        this.address = source && source.address || null;
        this.device_name = source && source.device_name || null;
        this.proposed_device_name = source && source.proposed_device_name || null;
        this.active = source && source.active || null;
        this.individual_id = source && source.individual_id || null;
    }

    generateDeviceName() {
        this.device_name = this.name != undefined ? this.name.replace(/ /g, '_').toUpperCase() : undefined;
    }
}
